import { AxiosError } from 'axios';
import { logger } from '@/utils/logger.ts';
import { HTTP_STATUS } from '@/constants/http.constant.ts';
import { useAuthStore } from '@/store/auth.store.ts';

export function handleAxiosError(error: unknown): Error {
  let message = 'An error occurred';

  if (error instanceof AxiosError) {
    if (error.response) {
      const status = error.response.status;
      message =
        (error.response.data as { message?: string })?.message ?? message;

      switch (status) {
        case HTTP_STATUS.BAD_REQUEST:
          logger.error('⚠️ Bad Request:', message);
          break;

        case HTTP_STATUS.UNAUTHORIZED:
          logger.error('⚠️ Unauthorized:', message);
          useAuthStore.getState().logout();
          break;

        case HTTP_STATUS.FORBIDDEN:
          logger.error('⚠️ Forbidden:', message);
          break;

        case HTTP_STATUS.NOT_FOUND:
          logger.warn('⚠️ Not Found:', message);
          break;

        case HTTP_STATUS.INTERNAL_SERVER_ERROR:
          logger.error('⚠️ Internal Server Error:', message);
          throw new AxiosError('Internal Server Error', '500');

        default:
          logger.error('⚠️ Unexpected Error:', message);
      }
    } else if (error.request) {
      logger.error('⚠️ No Response:', error.message);
    } else {
      logger.error('⚠️ Error:', error.message);
    }
  } else {
    logger.error('⚠️ Error: Unknown Error', error);
  }

  return error instanceof AxiosError ? error : new Error(message);
}
